














import { defineComponent, ref } from "@vue/composition-api";
import { LearnerGoalsStoreKey } from '@/store/StoreInjectionKeys';
import { injectStrict } from '@/lib/utils';
import { GoalProgram } from "@/generated/api.clients";

export default defineComponent({
  name: 'GoalInputAdd',
  setup() {
    const learnerGoalsStore = injectStrict(LearnerGoalsStoreKey);
    const newGoal = ref('');

    function addGoal() {
      if(newGoal.value) {
        learnerGoalsStore.actions.addGoal(newGoal.value, undefined);
        newGoal.value = '';
      }
    }

    return {
      newGoal,
      addGoal
    }
  }
})
